import { NOTI_CAMPAIGN_PATH } from "@/constants";

export const NOTI_CAMPAIGN_LIST_PATH = "list";

export const getNotiCampaignListUrl = () =>
  `/${NOTI_CAMPAIGN_PATH}/${NOTI_CAMPAIGN_LIST_PATH}`;
